import { useEffect } from 'react';

/**
 * Hook to dynamically set the favicon based on the tenant
 * @param tenantId - The current tenant ID (e.g., 'llt', 'ltr', 'ltn')
 */
export const useFavicon = (tenantId?: string) => {
  useEffect(() => {
    if (typeof document === 'undefined') return;

    // Find existing favicon link element
    let link = document.querySelector(
      'link[rel="icon"]',
    ) as HTMLLinkElement | null;

    // Create link element if it doesn't exist
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/x-icon';
      document.head.appendChild(link);
    }

    const faviconPath = tenantId
      ? `/favicons/${tenantId}.ico`
      : '/favicons/favicon.ico';

    // Check if the favicon exists by attempting to load it
    const img = new Image();
    img.onload = () => {
      // Favicon exists, set it
      link!.href = faviconPath;
    };
    img.onerror = () => {
      // Favicon doesn't exist, use default
      link!.href = '/favicons/favicon.ico';
    };
    img.src = faviconPath;
  }, [tenantId]);
};
